import React, { useState } from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { RetailHealthModel } from './RetailHealthModel';
import './RetailHealthWidget.css';

type Props = {
  className: string;
  title: string;
  description: string;
  avatar: string;
  link: string | undefined;
};

const RetailHealthWidget: React.FC<Props> = ({ className, title, description, avatar, link }) => {
  const [modalShow, setModalShow] = useState(false);
  

  return (
    <div className="retail-health-widget">
      <div className={`hoverable cursor-pointer`} role="button" onClick={() => setModalShow(true)}>
        <img src={toAbsoluteUrl('/media/partner/retailhealth.png')} width="100%" alt='Logo' className='card-p-5 shadow rounded-corners' />
      </div>
      <RetailHealthModel show={modalShow} handleClose={() => setModalShow(false)} />
    </div>
  );
};

export { RetailHealthWidget };
